/** zh-CN catalogue `ir` (W3-09; English: src/core/ir/ir.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'ir',
  locale: 'zh-CN',
  messages: {
    'lift.eventSkipped': '已略过一个拍数无效、长度为负或在上一个事件结束前就开始的事件。',
    'lift.noteSkipped': '已略过一个拍数无效的音符。',
    'lift.fatherMissing': '判定线 {line} 将判定线 {father} 设为父线，但该判定线不存在。已移除父线。',
    'lift.fatherCycle': '判定线 {line} 通过其父线成为了自己的祖先（Phira 会拒绝这样的谱面）。已移除其父线。',
    'lift.groupMissing':
      '判定线 {line} 属于分组 {group}，但谱面的分组列表中没有它。已将该判定线移出分组（只有 RPE 使用分组）。',
    'lift.gifOnNonGif': '“{texture}”不是 GIF，其上的 GIF 进度只保留在项目文件中。带有它的谱面 Phira 无法加载。',
    'lift.extraBpmRetimed': 'extra.json 有自己的 BPM 列表，与谱面的不同。特效和视频的时间已经过秒数换算。',
    'lift.unknownShader': '特效着色器“{shader}”不是内置着色器，也不以“/”开头。已将其读作谱面包中的文件“{shader}”。',
    'lift.videoAttachMissing': '一个视频绑定到了不存在的判定线 {line}（Phira 会崩溃）。已解除该视频的绑定。',
    'lift.effectVarDuplicate': '特效变量“{name}”被设置了两次。已使用最后一个值。',
    'lift.effectVarInvalid': '无法读取特效变量“{name}”的值。已将其设为 null（在 Phira 中为 0）。',
    'lift.extraSliceOneKey':
      '一个 extra.json 关键帧只给出了 easingLeft 和 easingRight 中的一个。Phira 对缺失的一个使用 0 或 1；写出时会同时写出两者，或在它们为 0 和 1 时两者都不写。',
    'lift.videoVarNull': '一个视频将“{which}”设为 null，Phira 会将其读作默认值。写出时不包含“{which}”字段。',
    'lift.videoTimeNormalized': '视频的起始拍数不是最简分数。写出时会使用最简分数（Phira 在同一时间播放）。',
    'lower.bakedSpeed':
      '为适应经典流速模式，已将 {segments, plural, other {# 个带缓动的流速区段}}拆分为 {pieces, plural, other {# 个线性分段}}。距离的最大差异为 {error} px。',
    'lower.bakedSpeedInexact':
      '有 {count, plural, other {# 个流速区段}}使用了 Phira 无法计算的缓动切割，已导出为单个线性分段。',
    'lower.paddedLines':
      '已用中性事件和 RPE 默认值填充 {count, plural, other {# 条判定线}}，使 RPE 以相同方式打开。Phira 中没有差别。',
    'lower.staleRawTriples': '有 {count, plural, other {# 个导入的拍数值}}已过期，已以规范化形式写出。',
    'lower.gapsMaterialised': '有 {count, plural, other {# 个钩定区段}}无法写为事件之间的空隙，已写为常量事件。',
  },
};

export default catalog;
